export const TYPES = {
    ROUTE: 'route',
    COUNTRY: 'country',
    LOCALITY: 'locality',
    POSTAL_CODE: 'postal_code',
    STREET_NUMBER: 'street_number',
    ADMINISTRATIVE_AREA_LEVEL_1: 'administrative_area_level_1'
};



// WEBPACK FOOTER //
// ./src/constants/GooglePlaces.js